import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from '../../../constants/modules.constant';
import { ObjectNames } from '../../../constants/object.names';
import { ActivityGroupListPayload, ActivityListPayload } from '../../../models/activity-list-payload.model';
import { FilterInColumn } from '../../../models/filter.model';
import { TimeZoneService } from '../../../services/timezone.service';
import { ActivityService } from "../activity.service";
import { ACTIVITY_LIST_FILTERS, ACTIVITY_LIST_FILTERS_ACCOUNTS } from './activity-list-available-filters';
import * as moment from 'moment';
import { ParseHelper } from '../../../parse.helper';
import { ACTIVITY_ICON_COLOR_LIST } from '../../../constants/activity-icon-color-list.constants';
import { ActivityCount } from '../../../models/activity-count.model';
import { StageWiseActivities } from '../../../models/stage-wise-activities.model';
import { environment } from 'src/environments/environment';
import { lowercaseFirstLetter } from '../../../helpers/lowercase-first-letter.helper';

@Component({
    selector: "app-shared-activities-list",
    templateUrl: "./shared-activities-list.component.html",
    styleUrls: ["./shared-activities-list.component.scss"],
    providers: [ActivityService],
})
export class SharedActivitiesListComponent implements OnInit, OnChanges, OnDestroy {

    @Input() currentDisplay: boolean = false;
	@Input() channelId: number;
    @Input() currentStageId: number;
	@Input() objectId: number;
	@Input() objectTypeId: number;
	@Input() selectedObject: any;
	@Input() objectType: string = "";
	@Input() contacts;
	@Input() selectedObjectStages = [];
	@Input() isViewMode = false;
	@Input() fromAccountView = false;

    @Output() dialogClosed = new EventEmitter<any>();

    private ngUnsubscribe$: Subject<any> = new Subject<void>();

    activityLogList: any[] = [];
    activityLogGroupList: any[] = [];

    loadingActivityLogs: boolean = false;
    expandCollapseText:string = 'Expand All';
    //Activity Filter
    filters = [
        {value: null, name: 'All Activity'},
        {value: 'user_activity', name: 'User Activity'},
        {value: 'system_activity', name: 'System Activity'},
        {value: 'favorite_activity', name: 'Favorite Activity'}
    ];

	filterType: string = null;
    enabledListCols = ACTIVITY_LIST_FILTERS;
    selectedGroupByValue: any = null;
    selectedGroupBy: any = null;
    filterInColumns: FilterInColumn[] = [];
    timelineExpanded: boolean = false;
    assestBaseUrl: string = environment.assestsBasePath;
	constructor(
		private activityService: ActivityService,
        private timeZoneService: TimeZoneService
	) {}

	ngOnChanges(changes: SimpleChanges) {

        if(changes?.channelId && changes?.channelId?.currentValue){
            this.channelId = changes?.channelId?.currentValue;
        }

        if(changes?.currentStageId && changes?.currentStageId?.currentValue){
            this.currentStageId = changes?.currentStageId?.currentValue;
        }

        if (changes && changes.selectedObject && changes.selectedObject.currentValue) {
			this.selectedObject = changes.selectedObject.currentValue;
		}

		if (changes && changes.selectedObjectStages && changes.selectedObjectStages.currentValue) {
			this.selectedObjectStages = changes.selectedObjectStages.currentValue;
		}

        if (changes && changes.objectTypeId && changes.objectTypeId.currentValue) {
			this.objectTypeId = changes.objectTypeId.currentValue;
            if(this.objectTypeId == AccountModuleId){
                this.enabledListCols = ACTIVITY_LIST_FILTERS_ACCOUNTS;
            }
		}

		if (changes && changes.objectType && changes.objectType.currentValue) {
			this.objectType = changes.objectType.currentValue;
            this.setObjectType();
		}

		if (changes?.isViewMode?.currentValue) {
			this.isViewMode = changes.isViewMode.currentValue;
		}

        if (changes && changes.objectId && changes.objectId.currentValue) {
			this.objectId = changes.objectId.currentValue;
            this.getActivityTimeline();
		}
	}

    ngOnInit(): void {
        if(this.objectType){
            this.setObjectType();
        }
    }

    hideDialog(){
        this.dialogClosed.emit(true);
    }

    setObjectType(){
        switch(this.objectType){
            case ObjectNames.LEAD:
                this.objectTypeId = LeadModuleId;
            break;
            case ObjectNames.ACCOUNT:
                this.objectTypeId = AccountModuleId;
            break;
            case ObjectNames.OPPORTUNITY:
                this.objectTypeId = OpportunityModuleId;
            break;
            case ObjectNames.CASES:
                this.objectTypeId = CaseModuleId;
            break;
        }
    }

    getActivityTimeline(){
        if(this.objectId && this.objectTypeId && this.currentDisplay){
            this.loadingActivityLogs = true;

            const activityPayload: ActivityListPayload = {
                moduleId: this.objectTypeId,
                channelId: this.channelId,
                stageId: this.currentStageId,
                moduleRecordId: this.objectId,
                filter: this.filterType,
                filterInColumns: this.filterInColumns
            }

            const activityGroupPayload: ActivityGroupListPayload = {
                ...activityPayload,
                groupByColumnName: this.selectedGroupByValue?.columnName,
                groupByColumnDataType: this.selectedGroupByValue?.fieldDataType,
                timezone: (this.selectedGroupByValue?.isDateWithTime) ? this.timeZoneService.getUserTimeZoneDescription() : null
            }

            if(this.selectedGroupByValue){
                this.activityService.getActivityGroupList(activityGroupPayload).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response)=>{
                        this.loadingActivityLogs = false;
                        this.activityLogGroupList = response;
                        if(this.activityLogGroupList?.length > 0){
                            this.activityLogGroupList[0]['expanded'] = true;
                        }
                        if(this.selectedGroupByValue?.fieldDataType == 'DateTime'){
                            this.activityLogGroupList.forEach((data)=>{
                                data.groupByValue = data?.groupByValue ? moment(data?.groupByValue).format("MM/DD/YYYY") : null;
                            });
                        }
                        this.generateActvityCounts();
                    },
                    error: (error)=>{
                        this.loadingActivityLogs = false;
                    }
                })
            }else{
                this.activityService.getActivityList(activityPayload).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
                    next: (response)=>{
                        this.loadingActivityLogs = false;
                        this.activityLogList = response;

                        const activityCounts: ActivityCount[] = ParseHelper.DeepCopy(ACTIVITY_ICON_COLOR_LIST);
                        activityCounts.map(activityGroup=>{
                            this.activityLogList.map(activity=> {

                                if (activity?.objectData?.activityFeedPayload?.payload && typeof activity?.objectData?.activityFeedPayload?.payload == 'string') {
                                    activity.payloadDetails = JSON.parse(activity.objectData.activityFeedPayload?.payload);
                                    activity.payloadDetails = lowercaseFirstLetter(activity.payloadDetails);
                                }

                                if(activityGroup.activityNames.includes(activity?.activityName)
                                    && ((activityGroup.types==null && !activity.type) || (activityGroup.types!==null && (activityGroup.types.length==0 || activityGroup.types.includes(activity.type))))
                                    && (activityGroup.subTypes.length==0 || activityGroup.subTypes.includes(activity.subType))){
                                        activity['activityGroup'] = activityGroup;
                                }
                            });
                        });
                    },
                    error: (error)=>{
                        this.loadingActivityLogs = false;
                    }
                })
            }
        }
    }

    generateActvityCounts(){
        this.activityLogGroupList.filter(a=> a.activities?.length>0).map(stageDetails=>{
            const activityCounts: ActivityCount[] = ParseHelper.DeepCopy(ACTIVITY_ICON_COLOR_LIST);
            activityCounts.map(activityGroup=>{

                stageDetails.activities.map(activity=> {

                    if (activity?.objectData?.activityFeedPayload?.payload && typeof activity?.objectData?.activityFeedPayload?.payload == 'string') {
                        activity.payloadDetails = JSON.parse(activity.objectData.activityFeedPayload?.payload);
                        activity.payloadDetails = lowercaseFirstLetter(activity.payloadDetails);
                    }

                    if(activityGroup.activityNames.includes(activity?.activityName)
                        && ((activityGroup.types==null && !activity.type) || (activityGroup.types!==null && (activityGroup.types.length==0 || activityGroup.types.includes(activity.type))))
                        && (activityGroup.subTypes.length==0 || activityGroup.subTypes.includes(activity.subType))){
                            activity['activityGroup'] = activityGroup;
                    }
                });

                activityGroup.counts = stageDetails.activities.filter(activity=> (activityGroup.activityNames.includes(activity?.activityName)
                && ((activityGroup.types==null && !activity.type) || (activityGroup.types!==null && (activityGroup.types.length==0 || activityGroup.types.includes(activity.type))))
                && (activityGroup.subTypes.length==0 || activityGroup.subTypes.includes(activity.subType))))?.length||0;
            });
            stageDetails.allActivities = stageDetails.activities;
            stageDetails['activityCounts'] = activityCounts.filter(a=> a.counts>0);
        });
    }

    filterActivitiesByCount(stageDetails: StageWiseActivities,countDetails: ActivityCount){
        stageDetails['expanded'] = true;
        if(stageDetails?.filteredCounts?.id==countDetails.id){
            stageDetails.filteredCounts = null;
            stageDetails.activities = stageDetails.allActivities;
        }else{
            stageDetails.filteredCounts = countDetails;
            stageDetails.activities = stageDetails.allActivities.filter(a=> a?.activityGroup?.id==countDetails?.id);
        }
    }

	filterActivities(filterType) {
		this.filterType = filterType;
		this.getActivityTimeline();
	}

    resetFilters(reloadList: boolean = false){
        this.applyFilters({selectedFilter: null,selectedColumnsForSaveFilterFieldsChannelWise: null}, reloadList);
    }

    applyFilters(event: { selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[]}, reloadList: boolean = true) {
        this.filterInColumns = event?.selectedFilter||null;
        if (reloadList) {
            this.getActivityTimeline();
        }
    }

    showGroupBy() {
        this.selectedGroupBy = this.selectedGroupByValue || null;
    }

    applyGroup() {
        this.selectedGroupByValue = this.selectedGroupBy;
        this.activityLogGroupList = [];
        this.getActivityTimeline();
    }

    resetGroup(reloadList: boolean = false) {
        this.selectedGroupBy = null;
        this.selectedGroupByValue = null;
        if(reloadList){
            this.activityLogGroupList = [];
            this.getActivityTimeline();
        }
    }

    loadMore(){

    }

    toogleTimelineActivity(stageDetails: any){
        stageDetails['expanded'] = !stageDetails?.expanded;
    }

    expanAllActivities(){
        this.timelineExpanded = !this.timelineExpanded ;
		if(this.timelineExpanded){
			this.expandCollapseText = 'Collapse All';
		}else{
			this.expandCollapseText = 'Expand All';
		}
        this.activityLogGroupList.map(stageDetails=>{
            stageDetails['expanded'] = this.timelineExpanded;
        });
    }

	collapseAllActivities(){
        this.timelineExpanded = false;

        this.activityLogGroupList.map(stageDetails=>{
            stageDetails['expanded'] = this.timelineExpanded;
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$?.next(null);
        this.ngUnsubscribe$?.complete();
    }
}
